const PERMISSION_KEY= "crm:content_template";
const PAGE_URL = {
    CONTENT_TEMPLATE_PAGE: "/admin/crm/content-template"
}

export {PERMISSION_KEY, PAGE_URL}

